import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import langMap from '../langMap';

const Edition = ({ lang, edition, onClickPrev, onClickNext }) => {
  const style = {
    color: edition.background,
  };
  return (
    <div className="c-edition">
      {
        lang === 'ar' ?
          <Link style={style} className="c-edition__home-link" to="/">
            <span className="c-edition__label">
              { langMap.edition.arabic }
            </span>
            <span className="c-edition__year">{edition.year}</span>
          </Link> :
          <Link style={style} className="c-edition__home-link" to="/">
            <span className="c-edition__year">{edition.year}</span>
            <span className="c-edition__label">
              { langMap.edition.full }
            </span>
          </Link>
      }
      <div className="c-edition__controls">
        <button
          onClick={onClickPrev}
          style={style}
          className="c-edition__controls__btn c-edition__controls__btn--prev"
        >&lt;</button>
        <button
          onClick={onClickNext}
          style={style}
          className="c-edition__controls__btn c-edition__controls__btn--next"
        >&gt;</button>
      </div>
    </div>
  );
};

export default Edition;

Edition.propTypes = {
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  onClickPrev: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./js/containers/Edition.js